import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ScreenType } from 'src/app/enums/ScreenType';
import { Visitor, VisitorTimeline } from 'src/app/models/visitor';
import { AumyeResponsiveScreenService } from 'src/app/services/screenResize/aumye-responsive-screen.service';

@Component({
  selector: 'app-visitor-timeline',
  templateUrl: './visitor-timeline.component.html',
  styleUrls: ['./visitor-timeline.component.scss'],
})
export class VisitorTimelineComponent {
  @Input() set visitorTableData(val: Visitor) {
    this.temp = val;
    this.rowIndex = val.visitorTimlineListUI?.length
      ? val.visitorTimlineListUI.length
      : 0;
    this.dataSource = val.visitorTimlineListUI;
  }
  @Input() set isIncidentDetailsClosed(val: boolean) {
    if (!val) {
      this.isShowDetails = false;
      this.expandedDetail = '';
    }
  }
  filteredDataSource: MatTableDataSource<Visitor>;
  tagLineAnpr = 'ANPR detection timeline for ';
  rowIndex = 0;
  screenSize: ScreenType;
  isShowDetails = false;
  expandedDetail = '';
  displayedColumns: string[] = ['index', 'checkin', 'checkout'];
  dataSource: VisitorTimeline[];
  temp: Visitor;
  constructor(
    private datePipe: DatePipe,
    private screen: AumyeResponsiveScreenService
  ) {
    this.screen.getScreenType().subscribe((screenData) => {
      this.screenSize = screenData;
    });
  }
  getFormatedDate(val: Date) {
    const checkIn = new Date(val + 'Z');
    let temp = this.datePipe.transform(checkIn, 'MMM dd, yyyy - hh:mm a');
    return temp;
  }
  ScreenType = ScreenType;
}
